var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c("div", { staticClass: "page" }, [
      _c(
        "div",
        { staticClass: "main-container", attrs: { id: "main-container" } },
        [
          _c(
            "van-pull-refresh",
            {
              staticClass: "refreshStyle",
              class: { flexClass: !_vm.listShow },
              on: { refresh: _vm.onRefresh },
              model: {
                value: _vm.isLoading,
                callback: function($$v) {
                  _vm.isLoading = $$v
                },
                expression: "isLoading"
              }
            },
            [
              _c(
                "van-list",
                {
                  attrs: { finished: _vm.finished, offset: 1 },
                  on: { load: _vm.onLoad },
                  model: {
                    value: _vm.ploading,
                    callback: function($$v) {
                      _vm.ploading = $$v
                    },
                    expression: "ploading"
                  }
                },
                [
                  _vm.listShow
                    ? _c(
                        "div",
                        _vm._l(_vm.goods, function(good, index) {
                          return _c(
                            "van-swipe-cell",
                            {
                              key: index.goodscode,
                              staticClass: "goods",
                              attrs: { "right-width": 65 }
                            },
                            [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      _vm.godetail(good)
                                    }
                                  }
                                },
                                [_c("goodCommon", { attrs: { good: good } })],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  attrs: { slot: "right" },
                                  on: {
                                    click: function($event) {
                                      _vm.clickDelete(good)
                                    }
                                  },
                                  slot: "right"
                                },
                                [
                                  _vm._v(
                                    "\n                                删 除\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.listShow
                    ? _c("div", { staticClass: "text-center" }, [
                        _c("img", { attrs: { src: _vm.noListUrl, alt: "" } }),
                        _vm._v(" "),
                        _c("p", { staticClass: "noCollection" }, [
                          _vm._v("暂无收藏！")
                        ])
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _vm.finishedOk && _vm.bottomShow ? _c("listBottom") : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "placeholder" })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }